import { render, staticRenderFns } from "./offersProductionPivot.vue?vue&type=template&id=11970e72&scoped=true&"
import script from "./offersProductionPivot.vue?vue&type=script&lang=js&"
export * from "./offersProductionPivot.vue?vue&type=script&lang=js&"
import style0 from "./offersProductionPivot.vue?vue&type=style&index=0&id=11970e72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11970e72",
  null
  
)

export default component.exports